import Modal from '@components/primitives/Modal/index.client'

export const WhyShouldIProvideMyMedicalRecordsModal = ({
  isModalOpen,
  setModalOpen,
}: {
  isModalOpen: boolean
  setModalOpen: (isOpen: boolean) => void
}) => {
  return (
    <Modal
      onClose={() => setModalOpen(false)}
      size='Large'
      visible={isModalOpen}
    >
      {/* key is used to force re-render so that the video stops playing when modal is closed */}
      <div className='pt-10' key={isModalOpen.toString()}>
        <div className='relative h-0 bg-transparent pb-[62.5%]'>
          <iframe
            //@ts-ignore - allowfullscreen is not recognized by React
            allowfullscreen='true'
            className='absolute inset-0 size-full'
            frameborder='0'
            mozallowfullscreen='true'
            src='https://www.loom.com/embed/ffa32127f89e4526a47e2bc31b0d2f03?sid=868f875d-9250-4698-9923-714b915283c0'
            webkitallowfullscreen
          ></iframe>
        </div>
      </div>
    </Modal>
  )
}
